import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    textTransform: 'none',
    fontWeight: 500,
    padding: '8px 16px',
  },
  primary: {
    background: 'linear-gradient(90deg, #D94936 0%, #B83B2A 100%)',
    color: '#fff',
    '&:hover': {
      background: 'linear-gradient(90deg, #C43F2D 0%, #A33525 100%)',
    },
  },
  secondary: {
    background: '#f5f5f5',
    color: '#333',
    '&:hover': {
      background: '#e0e0e0',
    },
  },
  loading: {
    opacity: 0.7,
    pointerEvents: 'none',
  },
  loadingIcon: {
    marginRight: theme.spacing(1),
    animation: '$spin 1s linear infinite',
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  },
}));

export interface ButtonProps extends Omit<MuiButtonProps, 'color' | 'variant'> {
  variant?: 'primary' | 'secondary';
  isLoading?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  isLoading = false,
  children,
  className,
  disabled,
  ...props
}) => {
  const classes = useStyles();

  return (
    <MuiButton
      className={classNames(
        classes.root,
        {
          [classes.primary]: variant === 'primary',
          [classes.secondary]: variant === 'secondary',
          [classes.loading]: isLoading,
        },
        className
      )}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading && (
        <span className={classes.loadingIcon}>
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" strokeOpacity="0.25" />
            <path
              d="M12 2C6.47715 2 2 6.47715 2 12C2 12.6213 2.05 13.2293 2.14805 13.8184"
              stroke="currentColor"
              strokeWidth="4"
              strokeLinecap="round"
            />
          </svg>
        </span>
      )}
      {children}
    </MuiButton>
  );
};

export default Button;
